import Vue from "vue";

import Vuex from "vuex";

import axios from "axios";
import Swal from 'sweetalert2'
import store from "@/store";


Vue.use(Vuex);

// const imgUrl = "https://wintershopthailand.com";

// const api = "https://localhost:5001";
// const api = "https://demo002.alexretnal.app";

// const api = process.env.NODE_ENV === 'production'
// ? 'https://demo002.alexrental.app'
// : 'https://localhost:5001';

const imgUrl = "https://brandnameforrent.com";

const alexImgUrl = "https://shop.alexrental.app";

// const api = process.env.NODE_ENV === 'production'
// ?  'https://brandnameforrent.com': 'http://localhost:8000'


const api = process.env.NODE_ENV === 'production'
?  'https://brandnameforrent.com': 'https://brandnameforrent.com'

// var tmp = localStorage.getItem('currentDomain');
// var currentDomain = JSON.parse(tmp);

var currentDomain = "a1265288-5381-4459-8c0d-bbfcd8b8510c";
var webToken = "a7wjWkX9aSm4ewE6FjF2JsqAAwhhqcJ0x8f210AQNobzAIcEWX";


export default new Vuex.Store({
  state: {
    shopId: currentDomain,
    // 4Jan2022
    apiHeader: {
        headers:{
            webToken: webToken
        }
      },
    ordernumber: "",
    hotItemNumber: 8,
    listnumber: 0,
    ordHead: {},
    cart: [],
    apiUrl: api,
    imageUrl: imgUrl + `/webimage/`,
    apiImageUrl: alexImgUrl + `/images/${currentDomain}/`,
    thai: {
      "day-names": ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."],
      "check-in": "วันเริ่ม",
      "check-out": "วันสุดท้าย",
      "month-names": [
        "มกราคม",
        "กุมภาพันธ์",
        "มีนาคม",
        "เมษายน",
        "พฤษภาคม",
        "มิถุนายน",
        "กรกฎาคม",
        "สิงหาคม",
        "กันยายน",
        "ตุลาคม",
        "พฤศจิกายน",
        "ธันวาคม"
      ]
    }
  },
  mutations: {},
  actions: {
    async shopInfo({commit}) {
      return new Promise((resolve, reject) => {
      axios.get(store.state.apiURL + "/api/shopinfo")
        .then((response) => {
          // this.noticeSuccess("บันทึกสำเร็จ");
          commit('SHOPINFO', response.data);
          resolve(response)
        })
        .catch((error) => {
          Swal.fire({
            icon: 'warning',
            title: "ไม่สามารถอัพเดตการตั้งค่าได้",
            // text: err.response.state,
          });
          reject(error)
        })
    });
    }
  }
});